// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607210840/js/" + chunkId + "." + {"44":"8795c15f","225":"226ab277","481":"0cc91791","486":"16e56fb9","770":"f7e801bc"}[chunkId] + ".0.8725564430442286.chunk.js";
};